<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table
          :headers='headers'
          :items='itens'
          class='elevation-1'
          :search="search"
          :items-per-page="itemsPerPage"
          @update:items-per-page=" v => itemsPerPage = v"
        >
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title>Listagem</v-toolbar-title>
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn v-has-permission="['desenvolvedor']" color='primary' dark class='mb-2' @click="editItem(null)">{{ $t('button.new') }}</v-btn>
              <ImportExportSequence @import="searchAll()" />
            </v-toolbar>

            <SearchField v-model="search" />
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy"/>
          </template>
          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{$t('button.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-has-permission="['desenvolvedor']" v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{$t('button.delete')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item.key.identifier)'>mdi-export</v-icon>
              </template>
              <span>{{$t('core.import_export.export')}}</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            {{$t('warnings.no_data_found')}}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/SequenceService'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'
import ImportExportSequence from './ImportExportSequence.vue'

export default {
  name: 'SequenceGrid',
  data: () => ({
    itens: [],
    search: ''
  }),
  mounted () {
    this.searchAll()
  },
  computed: {
    version () { return this.$versionable.versions.sequences },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('sequence_per_page') ? parseInt(this.$cookies.get('sequence_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('sequence_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('sequence.name'),
          value: 'key.identifier',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('sequence.value'),
          value: 'value',
          sortable: false,
          align: 'start'
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    }
  },
  methods: {
    searchAll () {
      Servico.findAll()
        .then(({ data }) => { this.itens = data })
    },
    editItem (item) {
      this.$emit('editItem', false, item)
    },
    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        Servico.delete(item.key.identifier)
          .then(() => this.searchAll())
          .catch((error) => {
            console.error(`${this.$t('warnings.error.delete')} : ${error}`)
          })
      }
    }
  },
  components: { LastModify, SearchField, ImportExportSequence }
}
</script>
